/** If value already looks like math ($...$, $$...$$, \(...\), \[...\]), return as-is.
 *  Otherwise wrap as inline math with $...$ so KaTeX renders it.
 *  Use for answers stored as raw LaTeX without delimiters.
 */
export const ensureInlineMath = (val: string): string => {
  const s = (val ?? '').trim();
  if (!s) return '';
  const alreadyMath =
    (/^\$.*\$$/.test(s) && !s.includes('\n')) || // $...$
    (/^\$\$[\s\S]*\$\$$/m.test(s)) || // $$...$$
    (/^\\\([\s\S]*\\\)$/.test(s)) || // \(...\)
    (/^\\\[[\s\S]*\\\]$/.test(s)); // \[...\]
  return alreadyMath ? s : `$${s}$`;
};
